import { Component, OnInit, ViewChildren, QueryList, ViewChild, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { OtherKpFilter } from '../../../models/other-kp-filter';
import { environment } from '../../../../../../environments/environment';
import { BusOtherKpFilterService } from '../../../services/bus-other-kp-filter.service';
import { RegionListFilter } from '../../../models/regions-list-filter';

const apiServer = environment.apiServer;
const controller = '/otherKp';
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-other-kp-main-modal-region',
  templateUrl: './other-kp-main-modal-region.component.html',
  styleUrls: ['./other-kp-main-modal-region.component.sass']
})
export class OtherKpRegionsComponent implements OnInit, AfterViewInit {

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  checkedDistributerMember: string[];

  dt: DataTables.Api;
  modelRegionFilter: RegionListFilter = new RegionListFilter();
  modelAuctionFilter: OtherKpFilter = new OtherKpFilter();
  dtOptionsRegionMembers: DataTables.Settings = {};
  dataSetRegions: any;

  constructor(private http: HttpClient, private bus: BusOtherKpFilterService) {
    this.checkedDistributerMember = [];
  }

  ngOnInit() {
    this.bus.currentClearModalFilter$.subscribe(key => {
      if (key === 'region') {
        this.nameInputModel.forEach(function (item) {
          item.nativeElement.checked = false;
        });
        this.checkedDistributerMember = [];
        this.onAuctionFilter('member');
      }
    });

    this.bus.currentClearSearchModalFields$.subscribe(key => {
      if (key === 'regionMemberName') {
        console.log(key);
        this.modelRegionFilter.name = null;
        this.onFieldChange();
      }
    });

    const that = this;
    this.dtOptionsRegionMembers = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.search = this.modelRegionFilter.name;

        that.http.post<DataTablesResponse>(`${apiServer + controller}/regionsList`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetRegions = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { orderable: false },
        { data: 'distrName', name: 'distrName' },
      ]
    };

  }
  onFieldChange() {
    this.dt.ajax.reload();
  }
  onSelectedRowMember(event, value) {

    if (event.target.checked) {
      this.checkedDistributerMember.push(`\'${event.target.value}\'`);
    } else {
      for (let i = 0; i < this.checkedDistributerMember.length; i++) {
        if (this.checkedDistributerMember[i] === `\'${event.target.value}\'`) {
          this.checkedDistributerMember.splice(i, 1);
        }
      }
    }
  }
  onSelectingRowsMember(event) {
    const that = this;

    this.nameInputModel.forEach(function (item) {
      item.nativeElement.checked = event.target.checked;

      if (event.target.checked) {
        that.checkedDistributerMember.push(`\'${item.nativeElement.value}\'`);
      } else {
        for (let i = 0; i < that.checkedDistributerMember.length; i++) {
          if (that.checkedDistributerMember[i] === `\'${item.nativeElement.value}\'`) {
            that.checkedDistributerMember.splice(i, 1);
          }
        }
      }
    });
  }

  onAuctionFilter(selectedType: string) {
    switch (selectedType) {
      case 'member':
        {
          this.modelAuctionFilter.region= this.checkedDistributerMember.map(function (n) {
            return `${n}`;
          }).join(',');
          break;
        }
    }

    this.bus.changeFilter(this.modelAuctionFilter);
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-region/other-kp-main-modal-region.component.ts